// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, Link, useParams } from '@tanstack/react-router';

// material ui
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from '@mui/material';

// feature-components
import ServiceActivationSwitch from '@/features/service-manager/components/ServiceActivationSwitch';

export const Route = createFileRoute(
  '/$accountId/_user/account/services/predictive-heat-control',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('service-manager');
  const { accountId } = useParams({
    from: '/$accountId/_user/account/services/predictive-heat-control',
  });

  return (
    <Card>
      <CardHeader
        title={t('services.pvo.title')}
        action={
          <ServiceActivationSwitch
            managedAccountId={accountId}
            servicePath="predictive-heat-control"
            ariaLabel={t('services.pvo.title')}
          />
        }
        slotProps={{
          title: { variant: 'h6', fontWeight: 600 }
        }}
      />
      <Divider />
      <CardContent>
        <Typography variant="body2" color="text.secondary">
          {t('services.pvo.description')}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          component={Link}
          to={`/${accountId}/operations/predictive-heat-control/groups`}
          size="small"
          color="primary"
          disableElevation
          sx={{
            ':hover': {
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
            },
          }}
        >
          {t('portfolioAnalysis.operationalStatus')}
        </Button>
      </CardActions>
    </Card>
  );
}

